// extracted by mini-css-extract-plugin
module.exports = {"vehicleInspectionTr":"VehicleInspectionDetail_vehicleInspectionTr__3Fruz","spin":"VehicleInspectionDetail_spin__1VKYW"};